/* AML apothecary scent cards - 2.17 (2026-09-13)
   Loaded (deferred) only by sections/aml-scent-cards.liquid.
   1. Family chips filter the cards and update the count line.
   2. View transition hand-off: the clicked card's photo box is named
      "aml-scent" just before navigation (never more than one element), and the
      name is cleared again whenever the page is shown or revealed. */
(() => {
  const VT_NAME = 'aml-scent';

  function clearNames() {
    document.querySelectorAll('.aml-sc__photo').forEach((el) => {
      if (el.style.viewTransitionName) el.style.viewTransitionName = '';
    });
  }

  function initSection(root) {
    if (root.dataset.amlScInit) return;
    root.dataset.amlScInit = 'true';

    const chips = root.querySelector('.aml-sc__chips');
    const count = root.querySelector('.aml-sc__count');
    const items = Array.from(root.querySelectorAll('.aml-sc__item'));

    if (chips) {
      let active = 'all';
      const render = () => {
        let shown = 0;
        items.forEach((item) => {
          const on = active === 'all' || item.dataset.family === active;
          item.hidden = !on;
          if (on) shown += 1;
        });
        chips.querySelectorAll('.aml-sc__chip').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip.dataset.family === active));
        });
        if (count) {
          const noun = shown === 1 ? 'scent' : 'scents';
          count.textContent = active === 'all' ? `${shown} ${noun}` : `${shown} ${noun} · ${active}`;
        }
      };
      chips.addEventListener('click', (event) => {
        const chip = event.target.closest('.aml-sc__chip');
        if (!chip || !chips.contains(chip)) return;
        active = chip.dataset.family;
        render();
      });
    }

    root.addEventListener('click', (event) => {
      const card = event.target.closest('.aml-sc__card');
      if (!card || !root.contains(card)) return;
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const photo = card.querySelector('.aml-sc__photo');
      if (!photo) return;
      clearNames();
      photo.style.viewTransitionName = VT_NAME;
    });
  }

  function initAll() {
    document.querySelectorAll('.aml-sc').forEach(initSection);
  }

  window.addEventListener('pageshow', clearNames);
  window.addEventListener('pagereveal', clearNames);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: re-init a section when it is re-rendered.
  document.addEventListener('shopify:section:load', initAll);
})();
